const columns = [
    { accessorKey: 'stateName', header: 'State', meta: { sortBy: 'StateName' }, cell: ({ getValue }) => getValue() ?? '—' },
    { accessorKey: 'code', header: 'Code', meta: { sortBy: 'Code' }, cell: ({ getValue }) => getValue() ?? '—' },
    { accessorKey: 'name', header: 'Name', meta: { sortBy: 'Name' }, cell: ({ getValue }) => getValue() ?? '—' },
];
export default columns;
